<div class="container-fluid d-flex justify-content-center align-items-center" style="min-height: 100vh;">
  <div class="text-center">
    <div class="alert alert-danger" role="alert">
      <h4 class="alert-heading">Access Denied</h4>
      <p>{{ message }}</p>
      <hr>
      <p class="mb-0">If you believe this is an error, please contact your system administrator.</p>
    </div>
  </div>
</div>
